import React, { useState, useEffect } from 'react';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Button, Modal } from "react-bootstrap";
import { LPP, DTP, IDCARD, MaterialTreinamento, Funil, MinhasAtividades,Ajuda, BibliotecaTreinamentosExternos, BibliotecaTreinamentosExternosAdmin } from "../../pages/Home/ModulePages";
import "../../pages/Home/Styles.css"
import { getUserAccessLevel } from '../../helpers/role';

export const HomeButton = ({ to, icon, name, expandable, ...props }) => {
    const [modal, setModal] = useState(false)
    const [arrayModule, setArrayModule] = useState([])


    useEffect(() => {
        SubArrays(name)
    });

    function handleShow() {
        setModal(true)
    }

    function handleClose() {
        setModal(false)
    }

    function SubArrays(name){
        if(name === 'LPP'){
            setArrayModule(LPP)
        }
        else if(name === 'DTP'){
            setArrayModule(DTP)
        }
        else if(name === 'Funil'){
            setArrayModule(Funil)
        }
        else if(name === 'ID Card'){
            setArrayModule(IDCARD)
        }
        else if (name === 'Biblioteca de Treinamento'){
            setArrayModule(MaterialTreinamento)
        }
        else if(name === 'Biblioteca de Documentos'){
            if(getUserAccessLevel() > 6){
                setArrayModule(BibliotecaTreinamentosExternosAdmin)
            }else{
                setArrayModule(BibliotecaTreinamentosExternos)
            }
        }
        else if(name === 'Ajuda'){
            setArrayModule(Ajuda)
        }
        else if(name === 'Minhas Atividades'){
            setArrayModule(MinhasAtividades)
        }
    }

    return (
        expandable === false ? (
        <a href={to} style={{...props.style}} className="col-5 col-md-2 px-6 py-8 rounded-xl mr-7 mb-7">
            {name === "Ajuda" ?
                <span className="svg-icon svg-icon-3x svg-icon-dark d-block my-2">
                <SVG src={toAbsoluteUrl(icon)} ></SVG>
                </span>
                :
                <span className="svg-icon svg-icon-3x svg-icon-info d-block my-2">
                <SVG src={toAbsoluteUrl(icon)} ></SVG>
                </span>

            }
                {name === 'Ferramenta de Busca' ? 
                    <span className="text-dark font-weight-bold font-size-h3">{name}</span>
                    :
                    <span className="text-dark font-weight-bold font-size-h6">{name}</span>
                }
        </a>
        ) : (
            <>
            <a onClick={handleShow} style={{...props.style}} className="col-5 col-md-2 px-6 py-8 rounded-xl mr-7 mb-7">
                <span className="svg-icon svg-icon-3x svg-icon-info d-block my-2">
                    <SVG src={toAbsoluteUrl(icon)} ></SVG>
                </span>
                <span className="text-dark font-weight-bold font-size-h6">{name}</span>
            </a>
            <Modal centered show={modal} onHide={handleClose}>
            <Modal.Header closeButton className="ModalHeaderEstilizado">
                <Modal.Title className="ModalTitleEstilizado">{name}</Modal.Title>
            </Modal.Header>
                {
                arrayModule.map(( page, index ) => (
                <div className="DivBotaoModalEstilizado">
                    <Button  style={{ width: "100%", height: "50px", border: "1px solid #62a8ee"}} key={index} href={page.to}>{page.name}</Button>
                </div>
                ))
                }
            </Modal>
            </>
        )
    )
}